import React from "react";
import styles from "./BannerEstatico.module.scss";
import { IBanners } from "@/components/templates/search/interfaces/IEstructuraPrincipal";

export const BannerSimple = ({ lateral }: IBanners) => {
	if (lateral === undefined || !lateral.activo) return null
	const { url, imagenes, alt } = lateral ?? {}
	const { srcDefault } = imagenes ?? {}
	return (
		<a href={url} target="_blank" rel="noreferrer" className={styles.cImg} id="banner-lateral" >
			<img src={srcDefault} className={styles.bannerSimple}  alt={alt} data-apartado="banner_lista_seo_lateral" data-nombre-campana="nombre_campaña_lateral" />
		</a>
	);
};
